/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import Profile from './Profile';
import { EProfilePageStatus } from './profile.interface';
import ProfilesList from './Profiles';

interface IProfilesProps {
  mode: EProfilePageStatus;
}

const Profiles: React.FunctionComponent<IProfilesProps> = (props: IProfilesProps) => {
  const { mode } = props;
  const SwitchRouter = () => {
    if (mode) {
      switch (mode) {
        case EProfilePageStatus.CREATE:
          return <Profile mode={mode} />;
        case EProfilePageStatus.EDIT:
          return <Profile mode={mode} />;
        case EProfilePageStatus.LIST:
          return <ProfilesList />;
        default:
          return <></>;
      }
    }
    return null;
  };

  return <SwitchRouter />;
};

export default Profiles;
